import { Empty, Table } from "antd";
import style from "./table.module.scss";
const CommonTable = ({
  data,
  columns,
  expandable,
  scrollWidth,
}: {
  data: any;
  columns: any;
  expandable?: any;
  scrollWidth?: number;
}) => {
  return (
    <div className={style["container"]}>
      {data.length > 0 ? (
        <Table
          bordered
          columns={columns}
          // dataSource={data}
          dataSource={data.map((item: any) => ({ ...item, key: item._id }))}
          expandable={expandable}
          pagination={false}
          scroll={{ x: scrollWidth ? scrollWidth : 300 }}
        />
      ) : (
        <Empty style={{ height: "80vh" }} />
      )}
    </div>
  );
};

export default CommonTable;
